import { some, isString } from 'lodash';
import * as i0 from "@angular/core";
var PermissionsService = /** @class */ (function () {
    function PermissionsService() {
    }
    // Ésta función devuelve si hay un permiso específico en el conjunto de permisos de un usuario
    PermissionsService.prototype.hasPermission = function (permission, usuario) {
        var _this = this;
        // siempre vamos a recalcular el conjunto de permisos ya que el usuario puede cambiar
        // podría mejorarse este recalculo si se observasen mejor los cambios del usuario
        this.permissionList = [];
        if (usuario !== undefined && usuario.groups) {
            usuario.groups.map(function (grupo) {
                _this.permissionList = _this.permissionList.concat(grupo.roles);
            });
        }
        permission = permission.trim();
        return some(this.permissionList, function (item) {
            if (isString(item)) {
                return item.trim() === permission;
            }
        });
    };
    PermissionsService.ngInjectableDef = i0.defineInjectable({ factory: function PermissionsService_Factory() { return new PermissionsService(); }, token: PermissionsService, providedIn: "root" });
    return PermissionsService;
}());
export { PermissionsService };
